import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const NoteWarningIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 15L13 15L13 17L11 17L11 15ZM11 7L13 7L13 13L11 13L11 7ZM19 3L14.82 3C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3L5 3C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5L3 19C3 19.27 3.06 19.54 3.16 19.78S3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21L19 21C20.1 21 21 20.1 21 19L21 5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5S12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5S11.59 2.75 12 2.75ZM19 19L5 19L5 5L19 5L19 19Z"
      fill="currentColor"
    />
  </svg>
);

NoteWarningIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(NoteWarningIcon);
